import { dataHomeAlt } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHomeAlt = /*#__PURE__*/createIcon(dataHomeAlt)
export default IconHomeAlt
